module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Anchor-right-down-1181018f349336a1d67628c620a7acbb.svg";